import { useQuery } from '@tanstack/react-query';
import { getCompanyIntegrations } from '../api';
import { messagingChannelsFromIntegrations } from '../utils/messagingChannels';

const EMPTY = { email: false, whatsapp: false, instagram: false };

export function useMessagingChannels(companyId) {
  const query = useQuery({
    queryKey: ['company-integrations', companyId],
    queryFn: () => getCompanyIntegrations(companyId),
    enabled: !!companyId,
  });

  const channels = query.isSuccess
    ? messagingChannelsFromIntegrations(query.data)
    : EMPTY;

  return {
    ...channels,
    isLoading: !!companyId && (query.isLoading || query.isPending),
    isError: query.isError || !companyId,
    isReady: query.isSuccess,
    refetch: query.refetch,
  };
}
